/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

jQuery( document).ready( function( $ ) {
    "use strict";

    Appointments.shortcodes.services = {
        thumbnailsCache: [],
        strings: null,

        init: function() {
            var self = this;
            this.strings = appointmentsStrings;
            this.$servicesSelector = $('.app_select_services');
            this.$submitButton = $('.app_services_button');

            if ( this.strings.autorefresh == '1' ) {
                this.$submitButton.hide();
            }

            this.bind();
        },

        bind: function() {
            var self = this;

            this.$submitButton.click(function(){
                var selected_service = self.$servicesSelector.val();
                if ( typeof selected_service=='undefined' || selected_service===null ) {
                    selected_service=self.strings.first_service_id;
                }

                self.reload( selected_service );
            });

            this.$servicesSelector.change(function(){
                var selected_service = $(this).val();

                if ( self.strings.autorefresh == '1' ) {
                    self.$submitButton.trigger( 'click' );
                    return false;
                }

                $('.app_service_excerpt').hide();
                $('#app_service_excerpt_'+selected_service).show();
            });
        },

        reload: function( service ) {
            window.location.href = this.strings.reload_url.replace('__selected_service__', service);
        }

    };

    Appointments.shortcodes.services.init();
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app-services.js